export enum UNAVAILABLE_RESOURCE_TYPE {
    PROFILE = "PROFILE",
    ARTICLE = "ARTICLE",
    COLLECTION = "COLLECTION",
    CERTIFICATE = "CERTIFICATE",
}

export enum UNAVAILABLE_REASON {
    NOT_SHARED = "NOT_SHARED",
    NOT_FOUND = "NOT_FOUND",
}
